module.exports = __webpack_public_path__ + "static/img/sup_logo_6.67e2c9f9.png";